import React from "react";
import bind from "memoize-bind";
import { sortBy, uniqBy } from "lodash";
import { FilterGroup, Form, FormControl, OrderDecorator, st, UsersRepository } from "lib/index";

export default class AffiliateListFilters extends React.PureComponent {
  componentDidMount() {
    this.getUsers();
  }

  componentWillUnmount() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subscriptions.length = 0;
  }

  handleFilterChange(prop, value) {
    this.handleFiltersChange({ [prop]: value });
  }

  handleFiltersChange(data) {
    const { filters, onFiltersChange } = this.props;
    onFiltersChange({
      ...filters,
      ...data,
    });
  }

  subscriptions = [];
  receptionists = [];

  getUsers() {
    //get users
    const sub = UsersRepository.getAll().subscribe((users) => {
      let isCurrentUserPresent = false;
      let filteredUsers = [];

      users.map((u) => {
        filteredUsers.push([u.id, u.admin_user.full_name]);

        // check if currently logged in user in present on the list
        if (u.id === st.authorize.member.id) {
          isCurrentUserPresent = true;
        }
      });

      // if its not present - add it.
      if (!isCurrentUserPresent) {
        filteredUsers.push([st.authorize.member.id, st.authorize.user.full_name]);
      }

      this.receptionists = [...filteredUsers];
    });
    this.subscriptions.push(sub);
  }

  getReceptionistOptions(aggregations) {
    const receptionistOptions = [];

    if (aggregations && aggregations.assigned_creator_id) {
      this.addNoneReceptionist(aggregations, receptionistOptions);
      this.receptionists.forEach((receptionist) => {
        const id = receptionist[0];
        const name = receptionist[1];

        receptionistOptions.push([id, `${name} (${aggregations.assigned_creator_id[id] || 0})`]);
      });
    }

    return receptionistOptions;
  }

  addNoneReceptionist(aggregations, receptionistOptions) {
    if (aggregations.assigned_creator_id[-1] !== undefined) {
      receptionistOptions.push([-1, `${I18n.t("papp.common.none")} (${aggregations.assigned_creator_id[-1]})`]);
    }
  }

  render() {
    const { filters, aggregations, currentCompany } = this.props;

    const filterStatusOptions = OrderDecorator.statuses.map((v) => [
      v,
      `${OrderDecorator.getStatusLabel(v, true)} (${(aggregations && aggregations.status[v]) || 0})`,
    ]);

    const authorPlaceOptions = [
      [
        "frontend",
        `${I18n.humanAttributeName("order", "author_place_frontend")} (${
          (aggregations && aggregations.author_place["frontend"]) || 0
        })`,
      ],
      [
        "partnerapp",
        `${I18n.humanAttributeName("order", "author_place_partnerapp")} (${
          (aggregations && aggregations.author_place["partnerapp"]) || 0
        })`,
      ],
      [
        "customerapp",
        `${I18n.humanAttributeName("order", "author_place_customerapp")} (${
          (aggregations && aggregations.author_place["customerapp"]) || 0
        })`,
      ],
    ];

    const receptionistOptions = this.getReceptionistOptions(aggregations);

    const supplierOptions = sortBy(
      uniqBy(
        [
          ...currentCompany.getPossibleSuppliers(),
          ...(st.authorize.member.role === "global_admin"
            ? st.authorize.user.accessed_companies.filter((c) => c.supplier)
            : []),
        ],
        (c) => c.id
      ),
      (c) => c.name
    ).map((c) => [c.id, `${c.name} (${(aggregations && aggregations.company_id[c.id]) || 0})`]);

    return (
      <Form>
        <FilterGroup enabled>
          <div className="u-positionRelative">
            <FormControl.Input
              placeholder={I18n.humanAttributeName("order", "id")}
              value={filters.id}
              onChange={bind(this.handleFilterChange, this, "id")}
              fluid
              inputClassName="u-paddingRight"
            />
            <FormControl.DeleteRowButton
              hidden={filters.id === null}
              onClick={bind(this.handleFilterChange, this, "id", null)}
            />
          </div>
        </FilterGroup>

        <FilterGroup
          label={I18n.humanAttributeName("order", "status")}
          enabled={filters.status !== null}
          onClear={bind(this.handleFilterChange, this, "status", null)}
        >
          <FormControl.MultipleCheckbox
            value={filters.status}
            onChange={bind(this.handleFilterChange, this, "status")}
            options={filterStatusOptions}
            grouped
          />
        </FilterGroup>

        <FilterGroup
          label={I18n.humanAttributeName("order", "created_on")}
          enabled={filters.created_on !== null}
          onClear={bind(this.handleFilterChange, this, "created_on", null)}
        >
          <FormControl.SeparateDateRange
            value={filters.created_on ? [filters.created_on.gte || null, filters.created_on.lte || null] : null}
            onChange={([gte, lte]) => {
              this.handleFilterChange("created_on", { gte, lte });
            }}
          />
        </FilterGroup>

        <FilterGroup
          label={I18n.humanAttributeName("order", "stock_time_range")}
          enabled={filters.stock_start_date !== null || filters.stock_end_date !== null}
          onClear={bind(this.handleFiltersChange, this, {
            stock_start_date: null,
            stock_end_date: null,
          })}
        >
          <span>{I18n.humanAttributeName("order", "stock_start_date")}</span>
          <FormControl.SeparateDateRange
            value={
              filters.stock_start_date
                ? [filters.stock_start_date.gte || null, filters.stock_start_date.lte || null]
                : null
            }
            onChange={([gte, lte]) => {
              this.handleFilterChange("stock_start_date", { gte, lte });
            }}
          />
          <span>{I18n.humanAttributeName("order", "stock_end_date")}</span>
          <FormControl.SeparateDateRange
            value={
              filters.stock_end_date ? [filters.stock_end_date.gte || null, filters.stock_end_date.lte || null] : null
            }
            onChange={([gte, lte]) => {
              this.handleFilterChange("stock_end_date", { gte, lte });
            }}
          />
        </FilterGroup>

        <FilterGroup
          label={I18n.humanAttributeName("order", "author_place")}
          enabled={filters.author_place !== null}
          onClear={bind(this.handleFilterChange, this, "author_place", null)}
        >
          <FormControl.MultipleCheckbox
            value={filters.author_place || []}
            onChange={bind(this.handleFilterChange, this, "author_place")}
            options={authorPlaceOptions}
            grouped
          />
        </FilterGroup>

        {st.authorize.company.reseller && (
          <div>
            <FilterGroup
              label={I18n.humanAttributeName("order", "receptionist")}
              enabled={filters.assigned_creator_id !== null}
              onClear={bind(this.handleFilterChange, this, "assigned_creator_id", null)}
            >
              <FormControl.Select
                fluid
                search
                includeBlank
                value={filters.assigned_creator_id}
                onChange={bind(this.handleFilterChange, this, "assigned_creator_id")}
                options={receptionistOptions}
              />
            </FilterGroup>

            {/*
              <FilterGroup
                label={I18n.humanAttributeName("order", "supplier")}
                enabled={filters.company_id !== null}
                onClear={bind(this.handleFilterChange, this, "company_id", null)}
              >
                <FormControl.Select
                  fluid
                  search
                  includeBlank
                  value={filters.company_id}
                  onChange={bind(this.handleFilterChange, this, "company_id")}
                  options={supplierOptions}
                />
              </FilterGroup>
            */}
          </div>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/affiliate/AffiliateListView/AffiliateListFilters.jsx